export const LOCALE_PREFIX = 'components.Dialog.components.GroupMembersImport.components.ImportContent'

export const COUNTRIES = {
    CZ: 'cz',
    SK: 'sk',
}

export const WARNING_MESSAGE_TYPES = {
    BAD_IMPORT_TEXT: 'badImportText',
    EMPTY_CONTAINER_TEXT: 'emptyContainerText',
}
